import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./controlepj.module.css";
import { AuthContext } from "../../../context/AuthContext";
import BottomNav from "../../../components/BottomNav";
import api from "../../../services/api";
import ApiButton from "../../../components/ApiButton/ApiButton";
import BackIcon from "../../../components/BackIcon";

export default function ControlePJ() {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const [dados, setDados] = useState([]);
    const [dadosdet, setDadosDet] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cardAberto, setCardAberto] = useState(null);

    const [modalNF, setModalNF] = useState(false);
    const [itemSelecionado, setItemSelecionado] = useState(null);
    const [numeroNF, setNumeroNF] = useState("");
    const [arquivoPDF, setArquivoPDF] = useState(null);
    const [previewPDF, setPreviewPDF] = useState(null);
    const [enviandoNF, setEnviandoNF] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);

    useEffect(() => { consultar(); }, []);

    const consultar = async () => {
        try {
            setLoading(true);
            const response = await api.get(`/colaborador/infocolaborador/?cpffun=${user.cpffun}&tipfun=${user.tipfun}&tipdad=F&mesano=0`);
            setDados(response.data);
        } catch (error) {
            console.error(error);
            alert("Erro ao consultar dados");
        } finally {
            setLoading(false);
        }
    };

    const detalhes = async (fpd159) => {
        try {
            setLoading(true);
            const response = await api.get(`/colaborador/infocolaborador/?cpffun=${user.cpffun}&tipfun=${user.tipfun}&tipdad=D&mesano=0&fpd160=${fpd159}`);
            setDadosDet(response.data);
        } catch (error) {
            console.error(error);
            alert("Erro ao consultar dados");
        } finally {
            setLoading(false);
        }
    };

    function toggleCard(index, fpd159) {
        if (cardAberto === index) {
            setCardAberto(null);
            setDadosDet([]);
        } else {
            setCardAberto(index);
            detalhes(fpd159);
        }
    }

    function abrirModalNF(e, item) {
        e.stopPropagation();
        setItemSelecionado(item);
        setNumeroNF("");
        setArquivoPDF(null);
        setPreviewPDF(null);
        setModalNF(true);
    }

    // Arquivo vai em base64 dentro do JSON (mesmo padrão do resto da API do
    // colaborador - não existe upload multipart real em nenhum endpoint do
    // srvPortal), não como multipart/form-data.
    function arquivoParaBase64(arquivo) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(",")[1] ?? "");
            reader.onerror = reject;
            reader.readAsDataURL(arquivo);
        });
    }

    async function enviarNF() {
        if (!numeroNF || !arquivoPDF || !itemSelecionado) {
            alert("Informe o número da NF e selecione o PDF");
            return;
        }
        try {
            setEnviandoNF(true);
            const arquivoBase64 = await arquivoParaBase64(arquivoPDF);
            await api.post("/colaborador/anexarnf", {
                fpd159: itemSelecionado.fpd159,
                numeroNF,
                nomeArquivo: arquivoPDF.name,
                arquivoBase64,
            });
            alert("NF enviada com sucesso");
            setModalNF(false);
            setPreviewPDF(null);
            consultar();
        } catch (err) {
            console.error(err);
            alert("Erro ao enviar NF");
        } finally {
            setEnviandoNF(false);
        }
    }

    // Mesmo padrão de visualizarPDF do Holerite/PLR/Adiantamento: abre a aba em
    // branco de forma síncrona (dentro do gesto de clique) e só depois troca a
    // URL pro blob quando o PDF chega - senão o navegador mobile bloqueia como
    // popup não solicitado.
    async function visualizarNF(e, item) {
        e.stopPropagation();
        const pdfWindow = window.open('', '_blank');
        try {
            setPdfLoading(true);
            const response = await api.get(`/colaborador/anexarnf/${item.fpd159}`, {
                responseType: "blob"
            });
            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: "application/pdf" })
            );
            if (pdfWindow) {
                pdfWindow.location.href = url;
            } else {
                alert("Permita pop-ups pra visualizar o PDF");
            }
        } catch (err) {
            if (pdfWindow) pdfWindow.close();
            console.error(err);
            alert("Erro ao visualizar NF");
        } finally {
            setPdfLoading(false);
        }
    }

    const formatarMoeda = (valor) =>
        new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor);

    return (
        <div className={styles.container}>

            {/* HEADER */}
            <div className={styles.header}>
                <button className={styles.btnVoltar} onClick={() => navigate(-1)}><BackIcon /></button>
                <div className={styles.headerTexto}>
                    <h2>Controle Financeiro</h2>
                    <p>Acompanhe suas informações financeiras</p>
                </div>
            </div>

            {/* PERÍODOS */}
            <div className={styles.card}>
                <span className={styles.cardTitulo}>📋 Períodos</span>

                {loading && dados.length === 0 && (
                    <div className={styles.loadingRow}>Carregando...</div>
                )}

                <div className={styles.listaPeriodos}>
                    {dados.map((item, index) => {
                        const aberto = cardAberto === index;
                        return (
                            <div key={index} className={`${styles.periodRow} ${aberto ? styles.aberto : ""}`}>

                                <div className={styles.periodoHeader} onClick={() => toggleCard(index, item.fpd159)}>
                                    <span className={styles.periodoTitulo}>{item.perini} — {item.perfin}</span>
                                    <span className={`${styles.periodoSeta} ${aberto ? styles.rotateSeta : ""}`}>▼</span>
                                </div>

                                <div className={styles.periodoValores}>
                                    <div className={styles.valorLinha}>
                                        <span>Valor Líquido</span>
                                        <span>{formatarMoeda(item.valliq)}</span>
                                    </div>
                                    <div className={styles.valorLinha}>
                                        <span>Valor NF</span>
                                        <span>{formatarMoeda(item.valora)}</span>
                                    </div>
                                    <div className={styles.valorLinha}>
                                        <span>Valor Complementar</span>
                                        <span>{formatarMoeda(item.valorb)}</span>
                                    </div>
                                    {item.numnot > 0 && (
                                        <div className={styles.nfAnexada}>
                                            <span className={styles.nfTag}>✓ NF {item.numnot}</span>
                                            <button
                                                className={styles.btnVerNF}
                                                onClick={(e) => visualizarNF(e, item)}
                                                disabled={pdfLoading}
                                            >
                                                Visualizar
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {item.valora > 0 && item.numnot <= 0 && (
                                    <ApiButton
                                        className={styles.btnNF}
                                        onClick={(e) => abrirModalNF(e, item)}
                                    >
                                        Anexar NF
                                    </ApiButton>
                                )}

                                {aberto && (
                                    <div className={styles.detalhes}>
                                        <span className={styles.detTitulo}>Lançamentos</span>
                                        {loading && dadosdet.length === 0 && (
                                            <div className={styles.loadingRow}>Carregando...</div>
                                        )}
                                        {dadosdet.map((det, i) => (
                                            <div key={i} className={styles.linhaDetalhe}>
                                                <span className={styles.desc}>{det.deseve}</span>
                                                <span className={det.tiplan === "Débito" ? styles.debito : styles.credito}>
                                                    {formatarMoeda(det.valpon)}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                )}

                            </div>
                        );
                    })}
                </div>
            </div>

            {/* MODAL NF */}
            {modalNF && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modal}>
                        <div className={styles.modalHeader}>
                            <span>Anexar Nota Fiscal</span>
                            <button className={styles.btnFechar} onClick={() => setModalNF(false)}>✕</button>
                        </div>
                        <div className={styles.modalBody}>
                            <input
                                className={styles.modalInput}
                                type="text"
                                placeholder="Número da NF"
                                value={numeroNF}
                                onChange={(e) => setNumeroNF(e.target.value)}
                            />
                            <input
                                className={styles.modalInput}
                                type="file"
                                accept="application/pdf"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        setArquivoPDF(file);
                                        setPreviewPDF(URL.createObjectURL(file));
                                    }
                                }}
                            />
                            {previewPDF && (
                                <div className={styles.previewContainer}>
                                    <iframe src={previewPDF} title="Preview NF" className={styles.previewPDF} />
                                </div>
                            )}
                            <div className={styles.modalButtons}>
                                <ApiButton className={styles.btnEnviar} onClick={enviarNF} disabled={enviandoNF}>
                                    {enviandoNF ? "Enviando..." : "Enviar"}
                                </ApiButton>
                                <button className={styles.btnCancelar} onClick={() => setModalNF(false)}>
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <BottomNav />
        </div>
    );
}
